// Rolling 12-hour countdown, mirrors the storefront urgency banner.
(function () {
  function render() {
    var els = document.querySelectorAll('[data-countdown]');
    if (!els.length) return;
    var twelveHours = 12 * 60 * 60 * 1000;
    var deadline = Math.ceil(Date.now() / twelveHours) * twelveHours;
    var total = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
    var values = {
      hours: Math.floor(total / 3600),
      mins: Math.floor((total % 3600) / 60),
      secs: total % 60
    };
    els.forEach(function (el) {
      var key = el.getAttribute('data-countdown');
      el.textContent = String(values[key]).padStart(2, '0');
    });
  }
  render();
  setInterval(render, 1000);
})();

// Bundle selector + buy now
(function () {
  var form = document.querySelector('[data-product-form]');
  if (!form) return;
  var options = form.querySelectorAll('[data-bundle-qty]');
  var qtyInput = form.querySelector('[data-quantity]');
  var button = form.querySelector('[data-buy-now]');

  function select(qty) {
    options.forEach(function (o) {
      o.setAttribute('aria-pressed', o.getAttribute('data-bundle-qty') === String(qty) ? 'true' : 'false');
    });
    if (qtyInput) qtyInput.value = qty;
    if (button) button.textContent = qty > 1 ? 'Buy now — ' + qty + ' pairs' : 'Buy now';
  }

  options.forEach(function (o) {
    o.addEventListener('click', function () { select(Number(o.getAttribute('data-bundle-qty'))); });
  });
  select(Number(form.getAttribute('data-default-qty') || 2));

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var qty = Number(qtyInput ? qtyInput.value : 1);
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: qty })
    })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var code = cart.item_count >= 3 ? 'BUNDLE3' : cart.item_count === 2 ? 'BUNDLE2' : '';
        window.location.href = code ? '/checkout?discount=' + code : '/cart';
      })
      .catch(function () { window.location.href = '/cart'; });
  });
})();
